import '../../../sass/alpha-modules/optional/_rousquille.scss'

import AlphaFilters from '../../abstracts/classes/alpha-filters'
import AlphaHelpers from '../../abstracts/classes/alpha-helpers'
import AlphaModule from '../../abstracts/classes/alpha-module'
import WpPluginFilters from '@nematis/hooks/lib/presets/wp-plugin-filters'

export default class Rousquille extends AlphaModule {
  getName() {
    return 'rousquille'
  }

  getDefaultConfig() {
    return {
      classesChanges: {
        // Buttons
        allowAll: {
          selector: '.allowAll',
          changes: {
            add: ['btn-primary']
          }
        },
        allow: {
          selector: '.allow:not(.allowAll)',
          changes: {
            add: ['btn-success']
          }
        },
        denyAll: {
          selector: '.denyAll',
          changes: {
            add: ['btn-outline-secondary']
          }
        },
        deny: {
          selector: '.deny:not(.denyAll)',
          changes: {
            add: ['btn-outline-danger']
          }
        },
        openPanel: {
          selector: '.openPanel',
          changes: {
            add: ['btn-outline-secondary'],
            remove: ['btn-outline']
          }
        },
        // Services
        servicesGroups: {
          selector: '#rousquilleGroups',
          changes: {
            add: ['list-unstyled']
          }
        },
        serviceGroupInfo: {
          selector: '.group .info',
          changes: {
            add: ['px-0', 'mb-0']
          }
        },
        serviceName: {
          selector: '.service-name',
          changes: {
            add: ['d-block', 'mb-2']
          }
        },
        serviceActions: {
          selector: '.actions',
          changes: {
            add: ['d-flex', 'gap-2']
          }
        },
        // Headings
        h1: {
          selector: '.h1',
          changes: {
            add: ['fs-4', 'd-block', 'text-center', 'mb-4', 'px-4']
          }
        }
      }
    }
  }

  _onLoad() {
    super._onLoad()

    this._addEventListeners()
  }

  _addEventListeners() {
    const config = this._getManager().getConfig()
    const moduleName = this.getName()

    // customize consent banner UI
    WpPluginFilters.addFilter(`${moduleName}.banners.alert.domElement`, (bannerEl) => {
      // add site logo in banner
      const infoEl = bannerEl.querySelector('.info')
      if (infoEl && config.siteLogo.length) {
        const logoEl = document.createElement('svg-component')
        logoEl.setAttribute('src', config.siteLogo)
        infoEl.insertBefore(logoEl, infoEl.firstChild)
      }

      // customize buttons & fonts
      const changesTypes = ['allowAll', 'openPanel', 'h1']
      this._doElementsClassesChanges(changesTypes, bannerEl, {
        type: 'consent_banner'
      })

      return bannerEl
    }, 'alpha/ui/banner')

    // customize services banner UI
    WpPluginFilters.addFilter(`${moduleName}.banners.services.domElement`, (bannerEl) => {
      // customize buttons & fonts
      const changesTypes = ['servicesGroups', 'serviceGroupInfo', 'service', 'allowAll', 'h1']
      this._doElementsClassesChanges(changesTypes, bannerEl, {
        type: 'services_banner'
      })

      return bannerEl
    }, 'alpha/ui/services/banner')

    // customize service item UI
    WpPluginFilters.addFilter(`${moduleName}.banners.services.service.domElement`, (serviceItemEl, service) => {
      serviceItemEl.classList.add('align-items-start', 'px-0')

      // customize buttons
      const changesTypes = ['allow', 'deny', 'serviceActions', 'h3']
      this._doElementsClassesChanges(changesTypes, serviceItemEl, {
        type: 'service_item',
        service
      })

      return serviceItemEl
    }, 'alpha/ui/services/item')

    // customize embedded content placeholder UI
    WpPluginFilters.addFilter(`${moduleName}.service.embeddedContent.placeholder.domElement`, (placeholderEl) => {
      // customize button
      const changesTypes = ['allow']
      this._doElementsClassesChanges(changesTypes, placeholderEl, {
        type: 'embedded_content_placeholder'
      })

      return placeholderEl
    })
  }

  _doElementsClassesChanges(changesTypes, refEl, context = {}) {
    changesTypes.forEach((changeType) => {
      const changeInfo = this._getClassesChangeInfo(changeType)
      if (changeInfo) {
        const elements = AlphaHelpers.smartQuerySelectorAll(changeInfo.selector, refEl)
        elements.forEach((el) => this._doElementClassesChanges(el, changeInfo, changeType, context))
      }
    })
  }

  _getClassesChangeInfo(changeType) {
    const config = this.getConfig()
    const changeInfo = config?.classesChanges?.[changeType]
    if (typeof changeInfo !== 'undefined' && typeof changeInfo.changes !== 'undefined') {
      return changeInfo
    }

    return null
  }

  _getElementClassesChanges(el, changeInfo, changeType, context = {}) {
    const moduleName = this.getName()
    const changes = changeInfo.changes
    switch (context.type) {
      case 'services_banner':
        switch (changeType) {
          case 'allowAll':
            changes.add = ['btn-success']
            break
          default:
            break
        }
        break
      default:
        break
    }

    return AlphaFilters.applyFilters(`module.${moduleName}.element.classesChanges`, changes, el, changeInfo, context)
  }

  _doElementClassesChanges(el, changeInfo, changeType, context = {}) {
    const changes = this._getElementClassesChanges(el, changeInfo, changeType, context)
    if (AlphaHelpers.objectHasAnyValues(changes)) {
      for (const entry of Object.entries(changes)) {
        const method = entry[0]
        const classes = entry[1]
        el.classList[method](...classes)
      }
    }
  }
}
